// extracted by mini-css-extract-plugin
export var actionRow = "_mw-6";
export var card = "_mw-0";
export var chevron = "_mw-5";
export var content = "_mw-2";
export var details = "_mw-3";
export var eventActionToggle = "_mw-4";
export var icon = "_mw-1";
export var iconBlue = "_mw-8";
export var iconBrand = "_mw-7";
export var iconGrayBlue = "_mw-9";
export var iconGreen = "_mw-a";
export var iconIndigo = "_mw-b";
export var iconOrange = "_mw-c";
export var iconPurple = "_mw-d";
export var iconRed = "_mw-e";
export var iconWarning = "_mw-f";